import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PayType, RecurrentType } from '@src/store/ducks/pay/types'

export const initialState = {
  payAndDeb: [] as PayType[],
  isLoading: false,
  recurrentCard: {} as RecurrentType,
  isSuccessCreditLimit: false,
  isLoadingCreditLimit: false,
  backError: '',
  creditLimitDescription: '',
}
const paySlice = createSlice({
  name: 'pay',
  initialState,
  reducers: {
    setPayAndDeb(state, { payload }: PayloadAction<PayType[]>) {
      state.payAndDeb = payload
    },
    setIsLoading(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload
    },
    setRecurrentCard(state, { payload }: PayloadAction<RecurrentType>) {
      state.recurrentCard = payload
    },
    setIsChecked(state, { payload }: PayloadAction<string>) {
      state.recurrentCard.status = payload
    },
    setIsSuccessCreditLimit(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessCreditLimit = payload
    },
    setIsLoadingCreditLimit(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingCreditLimit = payload
    },
    setBackError(state, { payload }: PayloadAction<string>) {
      state.backError = payload
    },
    setCreditLimitDescription(state, { payload }: PayloadAction<string>) {
      state.creditLimitDescription = payload
    },
  },
})
export type PayStateType = typeof initialState

export const {
  setPayAndDeb,
  setIsLoading,
  setRecurrentCard,
  setIsChecked,
  setIsSuccessCreditLimit,
  setIsLoadingCreditLimit,
  setBackError,
  setCreditLimitDescription,
} = paySlice.actions
export const payReducer = paySlice.reducer
